import React, { useState } from "react";
import SelectInput from "../../../../components/SelectInput";
import TextInput from "../../../../components/TextInput";
import { toast } from "../../../../components/toastNotification";
import Button from "../../../../components/Button";
// import { Button as B } from "../../../../components/buttons/Button";
import { CheckCircleIcon, XCircleIcon } from "@heroicons/react/24/solid";
import ConfirmBoxModal from "../../../../components/ConfirmBoxModal";
import useAddDistrict from "./hooks/useAddDistrict";
import useUpdateDistrict from "./hooks/useUpdateDistrict";
import useDistrict from "./hooks/useDistrict";
import useRegionOptions from "./hooks/useRegionOptions";
import CustomLoader from "../../../../components/CustomLoader";
import { useRecoilState, useRecoilValue } from "recoil";
import { accountAtom } from "../../../Login/atoms/AccountAtom";
import { useHistory } from "react-router-dom";
import {
  addStateDistrict,
  editStateDistrict,
  setFilterTextDistrict,
  setCheckStatusStateDistrict,
  rowForEditStateDistrict,
  disableButtonStateDistrict,
  selectedRowsStateDistrict,
  rowEditIdStateDistrict,
  setHiddenColumnStateDistrict,
  setLinkStateDistrict,
  setButtonLinkTextStateDistrict,
  setHierarchyIdStateDistrict,
  setDescriptionDistrictState,
  codeIdDistrict,
} from "../../OfficeHierarchy/District/atoms/atoms";
import { hierarchyTypeState } from "./../atoms/atoms";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { PERMISSIONS, FIELDPERMISSIONS } from "../../../PermissionsConstants";

import { getHierarchyType } from "./../atoms/atoms";
import { useOfficeHierarchy } from "../hooks/useOfficeHierarchy";
import useAddOfficeHierarchy from "../hooks/useAddOfficeHierarchy";
const DistrictForm = ({ employeeList }) => {
  //Hooks
  const AddDistrict = useAddDistrict();
  const AddNewDistrict = useAddOfficeHierarchy();
  const UpdateDistrict = useUpdateDistrict();

  const data = useDistrict();
  const history = useHistory();

  //Field Permission
  const contactPermission =
    FIELDPERMISSIONS.fieldpermission_officehierarchy_contact;
  const userPermissions = useRecoilValue(permissionsSelector);

  const [type] = useRecoilState(getHierarchyType);
  //Recoils Call
  const [actionAddState, setActionAddState] = useRecoilState(addStateDistrict);
  const [actionEditState, setActionEditState] =
    useRecoilState(editStateDistrict);
  const [buttonLinkState] = useRecoilState(setLinkStateDistrict);
  const [buttonTextLinkState] = useRecoilState(setButtonLinkTextStateDistrict);
  const [, setFilterText] = useRecoilState(setFilterTextDistrict);
  const [rowForEdit, setRowForEdit] = useRecoilState(rowForEditStateDistrict);
  const [hierarcyId] = useRecoilState(setHierarchyIdStateDistrict);
  const [, setSelectedRows] = useRecoilState(selectedRowsStateDistrict);
  const [, setEditRowId] = useRecoilState(rowEditIdStateDistrict);
  const [checkStatus, setCheckStatus] = useRecoilState(
    setCheckStatusStateDistrict
  );
  const [, setDisabledButton] = useRecoilState(disableButtonStateDistrict);
  const [, sethideColumn] = useRecoilState(setHiddenColumnStateDistrict);
  const [codeId] = useRecoilState(codeIdDistrict);
  const [description] = useRecoilState(setDescriptionDistrictState);
  const userAccount = useRecoilValue(accountAtom);
  const [hierarchyType, setHierarchyType] = useRecoilState(hierarchyTypeState);
  //Local States
  const [changed, setChanged] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [hasDistrict, setHasDistrict] = useState(false);
  const [districtExist, setDistrictExist] = useState(false);
  const [, setEmpTypeIsExistState] = useState(false);
  const [openModalEdit, setOpenModalEdit] = useState(false);
  const [openRegionModal, setOpenRegionModal] = useState(false);
  const parentOfficeHierarchies = useOfficeHierarchy()?.data?.data.map((x) => {
    return {
      value: x.idC,
      label: x.hierarchyCode + "-" + x.officeHierarchyName,
    };
  });
  const regionOptions = useRegionOptions()
    ?.filter((x) => x.isActive)
    .map((x) => {
      return { label: x.regionCode + " - " + x.regionName, value: x.regionId };
    });
  const defaultRegion = useRegionOptions()
    ?.filter((x) => x.regionId === rowForEdit.regionId)
    .map((x) => {
      return { label: x.regionCode + " - " + x.regionName, value: x.regionId };
    });
  const employeeOptions = employeeList
    ?.filter((x) => x.status !== "Terminated")
    .map((x) => {
      return {
        label: x.employeenumber + " - " + x.fullname,
        value: x.employeenumber,
        email: x.email,
        empNo: x.employeenumber,
        fullName: x.fullname,
      };
    });
  const defaultEmployee = employeeList
    ?.filter((x) => x.fullname === rowForEdit.districtManager)
    .map((x) => {
      return {
        label: x.employeenumber + " - " + x.fullname,
        value: x.employeenumber,
        email: x.email,
        empNo: x.employeenumber,
        fullName: x.fullname,
      };
    });
  const defaulValues = {
    districtId: 0,
    Code: "",
    Name: "",
    districtManager: "",
    managerEffectiveDate: "",
    managerEmail: "",
    managerUltiproNumber: "",
    regionId: 0,
    createdBy: "",
    createdOn: null,
    updatedBy: "",
    updatedOn: null,
    isActive: 0,
  };
  const defaultEditValues = {
    districtId: rowForEdit.districtId,
    districtCode: rowForEdit.districtCode,
    districtName: rowForEdit.districtName,
    districtManager: rowForEdit.districtManager,
    managerEmail: rowForEdit.managerEmail,
    managerUltiproNumber: rowForEdit.managerUltiproNumber,
    regionId: actionEditState ? rowForEdit.regionId?.toString() : "",
    updatedBy: "",
    updatedOn: null,
    isActive: rowForEdit.isActive,
  };
  const [addNewData] = useState([defaulValues]);
  const [editData] = useState([defaultEditValues]);

  const [selectedEmail, setSelectedEmail] = useState(
    actionEditState
      ? defaultEmployee?.length === 0
        ? ""
        : rowForEdit.managerEmail
      : addNewData.managerEmail
  );
  const [selectedEmpNo, setSelectedEmpno] = useState(
    actionEditState
      ? defaultEmployee?.length === 0
        ? ""
        : rowForEdit.managerUltiproNumber
      : addNewData.managerUltiproNumber
  );

  const handleAddDistrict = (
    SourceType,
    fieldName,
    inputvalue,
    email,
    empNo
  ) => {
    setChanged(true);
    if (fieldName === "regionId") {
      inputvalue = inputvalue.trim();
    }
    if (SourceType === "addDistrict") {
      if (fieldName === "districtCode") {
        addNewData.map((x) => (x.districtCode = inputvalue));
      }
      if (fieldName === "districtName") {
        addNewData.map((x) => (x.districtName = inputvalue));
      }
      if (fieldName === "districtManager") {
        addNewData.map((x) => (x.districtManager = inputvalue));
        addNewData.map((x) => (x.managerEmail = email));
        addNewData.map((x) => (x.managerUltiproNumber = empNo));
      }
      if (fieldName === "managerEffectiveDate") {
        addNewData.map((x) => (x.managerEffectiveDate = inputvalue));
      }
      if (fieldName === "regionId") {
        addNewData.map((x) => (x.regionId = inputvalue === 0 ? 0 : inputvalue));
      }
    }
    if (
      addNewData[0].districtName !== "" &&
      addNewData[0].districtCode !== "" &&
      addNewData[0].regionId !== null &&
      !userPermissions.includes(contactPermission)
    ) {
      setHasDistrict(true);
    } else if (
      addNewData[0].districtName !== "" &&
      addNewData[0].districtCode !== "" &&
      addNewData[0].regionId !== null &&
      addNewData[0].districtManager !== "" &&
      userPermissions.includes(contactPermission)
    ) {
      setHasDistrict(true);
    } else {
      setHasDistrict(false);
    }
    addNewData.map((x) => (x.createdOn = new Date().toISOString()));
    addNewData.map((x) => (x.createdBy = userAccount.username));
    addNewData.map((x) => (x.isActive = true));
  };

  //save changes
  const handleSaveAdd = (addNewData) => {
    if (changed) {
      if (!districtExist) {
        if (addNewData.filter((x) => x.districtName) !== "") {
          //call Insert
          AddNewDistrict(addNewData);
          if (buttonLinkState) {
            setTimeout(() => {
              handleLink();
            }, 3000);
          }
          setOpenModal(false);
        } else {
          toast.fire("Failed", "Please populate fields!", "error");
          setOpenModal(false);
        }
      } else {
        toast.fire("Failed", "The data already exists!", "error");
        setOpenModal(false);
      }
    } else {
      toast.fire("Failed", "No Changes have been made", "warning");
      setOpenModal(false);
    }
  };
  // end of saving changes

  const handleCheckBox = (checked) => {
    if (
      editData[0].districtName !== "" &&
      editData[0].districtCode !== "" &&
      editData[0].districtManager !== "" &&
      editData[0].regionId !== 0
    ) {
      setChanged(true);
    } else {
      setChanged(false);
    }
    checked ? setCheckStatus(true) : setCheckStatus(false);
    checked
      ? editData.map((x) => (x.isActive = true))
      : editData.map((x) => (x.isActive = false));
    editData.map((x) => (x.updatedOn = new Date().toISOString()));
    editData.map((x) => (x.updatedBy = userAccount.username));
  };

  const handleEditFieldsChange = (
    SourceType,
    fieldName,
    inputvalue,
    email,
    empNo
  ) => {
    setChanged(true);
    if (fieldName === "regionId") {
      inputvalue = inputvalue.trim();
    }
    if (SourceType === "editDistrict") {
      if (fieldName === "districtCode") {
        editData.map((x) => (x.districtCode = inputvalue));
      }
      if (fieldName === "districtName") {
        editData.map((x) => (x.districtName = inputvalue));
      }
      if (fieldName === "districtManager") {
        editData.map((x) => (x.districtManager = inputvalue));
        editData.map((x) => (x.managerEmail = email));
        editData.map((x) => (x.managerUltiproNumber = empNo));
      }
      if (fieldName === "regionId") {
        editData.map((x) => (x.regionId = inputvalue === 0 ? 0 : inputvalue));
      }
    }
    if (
      editData[0].districtName !== "" &&
      editData[0].districtCode !== "" &&
      editData[0].districtManager !== "" &&
      editData[0].regionId !== 0
    ) {
      setChanged(true);
    } else {
      setChanged(false);
    }
    editData.map((x) => (x.updatedOn = new Date().toISOString()));
    editData.map((x) => (x.updatedBy = userAccount.username));
  };

  //Save Edit changes
  const handleSaveEdit = (editData) => {
    if (changed) {
      if (!districtExist) {
        if (editData.filter((x) => x.districtName) !== "") {
          {
            UpdateDistrict(editData);
            setOpenModalEdit(false);
            if (!actionEditState) {
              setEditRowId([]);
              setSelectedRows([]);
              setEmpTypeIsExistState(false);
              setRowForEdit([]);
              setSelectedEmail("");
              setSelectedEmpno("");
              setChanged(false);
              setDisabledButton(false);
              sethideColumn(false);
            }
          }
        } else {
          toast.fire("Failed", "All fields must be filled!", "error");
          setOpenModalEdit(false);
        }
      } else {
        toast.fire("Failed", "District already exists!", "error");
        setOpenModalEdit(false);
      }
    } else {
      toast.fire("Saving Failed", "No Changes have been made", "warning");
      setEditRowId([]);
      setOpenModalEdit(false);
      setChanged(false);
      setActionEditState(false);
      setDisabledButton(false);
    }
  };
  // end of saving changes
  const handleLink = () => {
    history.push({
      pathname: "/carrieragreementmgmt/officehierarchy",
      state: {
        recordId: buttonTextLinkState !== "Add" ? hierarcyId + " " : " ",
        moduleName: "Office Hierarchy",
        subModuleName: buttonTextLinkState,
        selectedType: type,
        description: description,
        codeId: codeId,
      },
    });
    window.location.reload();
  };
  return (
    <div>
      {regionOptions ? (
        <div className="w-full">
          <div className="p-3 py-2 space-y-1 border-l-6  rounded-l-xl rounder-r-none box-shadow mt-2 ">
            <div className="flex w-full ">
              <div className="text-base text-primary font-bold w-full">
                {actionAddState ? "Add New District" : "Edit: "}{" "}
                {actionAddState ? "" : rowForEdit.districtName}
              </div>
              <div className="flex items-center justify-end space-x-2 w-full">
                <Button
                  className={`flex items-right shadow-md text-xs font-semibold text-white justify-right gap-x-1 rounded-full bg-senary hover:bg-senary px-3 py-1 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-senary focus:ring-opacity-70
              ${
                (actionAddState ? !hasDistrict : !changed)
                  ? "opacity-50"
                  : "opactiy-100"
              }`}
                  disabled={actionAddState ? !hasDistrict : !changed}
                  onClickFunction={() =>
                    actionAddState ? setOpenModal(true) : setOpenModalEdit(true)
                  }
                >
                  <CheckCircleIcon className="h-4 w-4" />
                  <div className=" self-center -mt-px">Save</div>
                </Button>
                <Button
                  className="flex items-right text-xs shadow-md font-semibold text-white justify-right gap-x-1 rounded-full bg-octonary bg-transparent hover:bg-octonary px-2 py-1 "
                  onClickFunction={() => {
                    if (buttonLinkState) {
                      handleLink();
                    } else {
                      setActionAddState(false);
                      setActionEditState(false);
                      setDisabledButton(false);
                      setFilterText("");
                      sethideColumn(false);
                      setEditRowId([]);
                      setRowForEdit([]);
                      setSelectedEmail("");
                      setSelectedEmpno("");
                      setHierarchyType({ Type: "", HierarchyType: "" });
                    }
                  }}
                >
                  <XCircleIcon className="h-4 w-4" />
                  <div className=" self-center -mt-px">Cancel</div>
                </Button>
              </div>
            </div>
            <div className="mt-2 h-1 w-full border-b-4 border-secondary "></div>
            <div className="italic text-secondary text-xs3">
              <b> Note: </b> All fields with * are required to fill
            </div>
            <div className="w-full -mx-2">
              {/* firstrow */}
              <div className="text-primary font-bold font-sans text-sm py-2">
                <div className="border-b mb-2 mt-2"></div>
                Information
              </div>
              <div className="space-y-1">
                <div className="grid grid-cols-2">
                  <div className="space-y-1">
                    <div className="w-full text-xs">
                      <div className="grid grid-cols-1 md:grid-cols-3  w-full items-center gap-2">
                        <label className="block font-medium text-gray-700 my-1 text-right mr-2">
                          District Name: <span className="text-red-500">*</span>
                        </label>
                        <div className="">
                          <TextInput
                            defaultValue={
                              actionEditState
                                ? rowForEdit.districtName
                                : addNewData.districtName
                            }
                            onChange={(e) =>
                              !actionEditState
                                ? handleAddDistrict(
                                    "addDistrict",
                                    "districtName",
                                    e.target.value
                                  )
                                : handleEditFieldsChange(
                                    "editDistrict",
                                    "districtName",
                                    e.target.value
                                  )
                            }
                          />
                        </div>
                      </div>
                    </div>
                    <div className="w-full text-xs">
                      <div className="grid grid-cols-1 md:grid-cols-3  w-full items-center gap-2">
                        <label className="block font-medium text-gray-700 my-1 text-right mr-2">
                          District Code: <span className="text-red-500">*</span>
                        </label>
                        <div className="">
                          <TextInput
                            defaultValue={
                              actionEditState
                                ? rowForEdit.districtCode
                                : addNewData.districtCode
                            }
                            onChange={(e) =>
                              !actionEditState
                                ? handleAddDistrict(
                                    "addDistrict",
                                    "districtCode",
                                    e.target.value
                                  )
                                : handleEditFieldsChange(
                                    "editDistrict",
                                    "districtCode",
                                    e.target.value
                                  )
                            }
                          />
                        </div>
                      </div>
                    </div>
                    {/* 2ndrow */}
                    <div className="w-full text-xs">
                      <div className="grid grid-cols-1 md:grid-cols-3  w-full items-center gap-2">
                        <label className="block font-medium text-gray-700 my-1 text-right mr-2">
                          Region: <span className="text-red-500">*</span>
                        </label>
                        <div className="">
                          <SelectInput
                            defaultValue={
                              actionEditState
                                ? defaultRegion
                                : addNewData.regionId
                            }
                            options={
                              parentOfficeHierarchies
                                ? parentOfficeHierarchies
                                : []
                            }
                            onChange={(e) =>
                              !actionEditState
                                ? handleAddDistrict(
                                    "addDistrict",
                                    "regionId",
                                    e ? e.value.toString() : 0
                                  )
                                : handleEditFieldsChange(
                                    "editDistrict",
                                    "regionId",
                                    e ? e.value.toString() : 0
                                  )
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="space-y-1">
                    <div className="w-full text-xs">
                      <div className="grid grid-cols-1 md:grid-cols-3  w-full items-center gap-2">
                        <label className="block font-medium text-gray-700 my-1 text-right mr-2">
                          Owner
                        </label>
                        <TextInput
                          defaultValue={
                            actionEditState ? "" : addNewData.createdBy
                          }
                          disabled={true}
                          value={userAccount.username}
                          onChange={(e) =>
                            !actionEditState
                              ? handleAddDistrict(
                                  "addDistrict",
                                  "owner",
                                  e.target.value
                                )
                              : handleEditFieldsChange(
                                  "editDistrict",
                                  "owner",
                                  e.target.value
                                )
                          }
                        />
                      </div>
                    </div>
                  </div>
                  {/* 3rdrow */}
                  <div className="grid  grid-cols-2 w-full  gap-5 m-2">
                    {!actionAddState ? (
                      <div className="grid grid-cols-3">
                        <label className="block font-medium text-gray-700  text-right mr-2">
                          Active:
                        </label>
                        <div className="flex justify-left space-x-1 cursor-pointer">
                          <input
                            type="checkbox"
                            className="flex items-left space-x-1 cursor-pointer"
                            defaultChecked={rowForEdit.isActive}
                            onClick={(e) => {
                              handleCheckBox(e.target.checked);
                            }}
                          />
                          <label
                            className="cursor-pointer text-green-600 text-xs"
                            name="Status"
                          >
                            {checkStatus
                              ? "Uncheck to Deactivate"
                              : "Check to Activate"}
                          </label>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <div name="leaderShip">
                  <div className="text-primary font-bold font-sans text-sm py-2">
                    <div className="border-b mb-2 mt-2"></div>
                    Leadership
                  </div>
                  <div className="w-full -mx-2">
                    {/* firstrow */}
                    <div className="text-xs font-medium ">
                      {userPermissions.includes(contactPermission) ? (
                        <div className="grid  grid-cols-2 w-full  gap-5 m-2 ">
                          <div className="grid grid-cols-3">
                            <label className="block font-medium text-gray-700 my-1 text-right mr-2">
                              Manager: <span className="text-red-500">*</span>
                            </label>
                            <div className="">
                              <SelectInput
                                defaultValue={
                                  actionEditState
                                    ? defaultEmployee
                                    : addNewData.districtName
                                }
                                isSearchable={true}
                                options={employeeOptions ? employeeOptions : []}
                                onChange={(e) => {
                                  setSelectedEmail(e ? e.email : "");
                                  setSelectedEmpno(e ? e.empNo : "");
                                  !actionEditState
                                    ? handleAddDistrict(
                                        "addDistrict",
                                        "districtManager",
                                        e ? e.fullName : "",
                                        e ? e.email : "",
                                        e ? e.empNo : ""
                                      )
                                    : handleEditFieldsChange(
                                        "editDistrict",
                                        "districtManager",
                                        e ? e.fullName : "",
                                        e ? e.email : "",
                                        e ? e.empNo : ""
                                      );
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                      {userPermissions.includes(contactPermission) ? (
                        <div className="grid  grid-cols-2 w-full  gap-5 m-2 ">
                          <div className="grid grid-cols-3">
                            <label className="block font-medium text-gray-700 my-1 text-right mr-2">
                              Manager Email:
                            </label>
                            <div className="opacity-50">
                              <TextInput
                                value={selectedEmail}
                                disabled
                                type="email"
                                placeholder={"Select Manager"}
                              />
                            </div>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                      {userPermissions.includes(contactPermission) ? (
                        <div className="grid  grid-cols-2 w-full  gap-5 m-2 ">
                          <div className="grid grid-cols-3">
                            <label className="block font-medium text-gray-700 my-1 text-right mr-2">
                              Manager Ultipro Number:
                            </label>
                            <div className="opacity-50">
                              <TextInput
                                value={selectedEmpNo}
                                placeholder={"Select Manager"}
                              />
                            </div>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>

                <div className="grid  grid-cols-3  gap-5 m-2"></div>
              </div>
            </div>
          </div>
          <div className="pr-2">
            <ConfirmBoxModal
              ModalTitle="Add District"
              qConfirmation=" Are you sure you want to add this?"
              isOpen={openModal}
              onClose={() => setOpenModal(false)}
              onClickFunction={() => {
                handleSaveAdd(addNewData);
              }}
            />
            <ConfirmBoxModal
              ModalTitle="Update District"
              qConfirmation=" Are you sure you want to update this?"
              isOpen={openModalEdit}
              onClose={() => setOpenModalEdit(false)}
              onClickFunction={() => {
                handleSaveEdit(editData);
              }}
            />
          </div>

          <div className="hidden sm:block" aria-hidden="true">
            <div className="py-2"></div>
          </div>
        </div>
      ) : (
        <div className="h-96">
          <CustomLoader />
        </div>
      )}
    </div>
  );
};

export default DistrictForm;
